module.exports = __webpack_public_path__ + "img/ico_select_player.657ec1a3.png";